import { render, staticRenderFns } from "./CareRecordEdit.vue?vue&type=template&id=78e5ba60&scoped=true"
import script from "./CareRecordEdit.vue?vue&type=script&lang=js"
export * from "./CareRecordEdit.vue?vue&type=script&lang=js"
import style0 from "./CareRecordEdit.vue?vue&type=style&index=0&id=78e5ba60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e5ba60",
  null
  
)

export default component.exports